<template>
    <Modal :title="pgettext('label', 'Estimated on scene')" @close="close" :closeOnClickOutside="false">
        <v-form @submit.prevent="onSubmit">
            <v-row>
                <v-col cols="12">
                    <v-alert v-for="message in nonFieldErrors" :title="message" type="error"></v-alert>
                    <!-- Red -->
                    <NumberSplitInput v-model="red" v-bind="redProps"
                                      class="mb-2"
                                      :label="pgettext('hospital capacity form label', 'red')"
                                      :min="0"/>

                    <!-- Yellow -->
                    <NumberSplitInput v-model="yellow" v-bind="yellowProps"
                                      class="mb-2"
                                      :label="pgettext('hospital capacity form label', 'yellow')"
                                      :min="0"
                                      control-variant="split"/>

                    <!-- Green -->
                    <NumberSplitInput v-model="green" v-bind="greenProps"
                                      class="mb-2"
                                      :label="pgettext('hospital capacity form label', 'green')"
                                      :min="0"
                                      control-variant="split"/>

                    <!-- Black -->
                    <NumberSplitInput v-model="black" v-bind="blackProps"
                                      class="mb-2"
                                      :label="pgettext('hospital capacity form label', 'black')"
                                      :min="0"
                                      control-variant="split"/>

                    <!-- Uninjured -->
                    <NumberSplitInput v-model="uninjured" v-bind="uninjuredProps"
                                      class="mb-2"
                                      :label="pgettext('injury_severity_level', 'uninjured')"
                                      :min="0"
                                      control-variant="split"/>

                    <v-btn :text="pgettext('action', 'Save')"
                           type="submit"
                           block
                    ></v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Modal>
</template>

<script setup>
import Modal from "@/components/modal/Modal";
import * as yup from "yup";
import {useMutation} from "@vue/apollo-composable";
import {HpoEstimatedOnSiteMutation} from "@/graphql/mutations/hpo/triage.graphql"
import NumberSplitInput from "../../forms/NumberSplitInput.vue";
import {useDjangoForm} from "@/utils/forms";
import {numberValidator, requiredMessage} from "@/utils/yupValidators";

const props = defineProps({
    hpoId: {
        type: String,
        required: true
    },
    patientCounts: {
        type: Object,
        require: true,
    },
})

const emit = defineEmits(['close'])

const {defineField, handleMutationSubmit, nonFieldErrors} = useDjangoForm({
    validationSchema: yup.object({
        red: numberValidator,
        yellow: numberValidator,
        green: numberValidator,
        black: numberValidator,
        uninjured: numberValidator,
    }),
    initialValues: {
        red: props.patientCounts.red,
        yellow: props.patientCounts.yellow,
        green: props.patientCounts.green,
        black: props.patientCounts.black,
        uninjured: props.patientCounts.uninjured,
    }
});

const [red, redProps] = defineField('red');
const [yellow, yellowProps] = defineField('yellow');
const [green, greenProps] = defineField('green');
const [black, blackProps] = defineField('black');
const [uninjured, uninjuredProps] = defineField('uninjured');


const {mutate} = useMutation(HpoEstimatedOnSiteMutation);


const onSubmit = handleMutationSubmit(mutate, {
    buildValues(values) {
        values.hpo = props.hpoId
    },
    onSuccess() {
        close();
    },
});




function close() {
    emit('close')
}

</script>